import * as constants from '../constants';
import { addCalculate, clearCalculate, getCalculate } from '../../item-calculate/constants';
import {
    addGroupCalculate,
    clearCalculatorMordovia,
    getCalculatorMordovia,
    setActiveCalculate
} from '../../mordovia/constants';

const initialState = {
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getInterpretation.success:
        case constants.addInterpretation.success:
        case constants.updateInterpretation.success: {
            return action.payload;
        }

        case getCalculate.success:
        case addCalculate.success: {
            const { agrochemical } = action.payload;
            return agrochemical;
        }

        case clearCalculatorMordovia.toString():
        case clearCalculate.toString():
        case constants.clearInterpretation.toString(): {
            return initialState;
        }

        case getCalculatorMordovia.success: {
            const calculator = { ...action.payload?.calculator?.agrochemical };
            return calculator;
        }

        case addGroupCalculate.success: {
            const calculator = { ...action.payload?.calculator?.agrochemical };
            return calculator;
        }

        case setActiveCalculate.toString(): {
            const calculator = { ...action.payload?.agrochemical };
            return calculator;
        }

        default:
            return state;
    }
}
